export const ACHIEVEMENT_TYPES = {
  GET_USER_ACHIEVEMENTS: "GET_USER_ACHIEVEMENTS",
  COMPLETE_TUTORIAL: "COMPLETE_TUTORIAL",
};